/**
 * Touch Device Detection Plugin
 * Detects if the device has touch capability and adds a class to body
 * This works in Chrome's device simulator and on real touch devices
 */
export default function TouchDeviceDetectionPlugin(Vue) {
  Vue.mixin({
    mounted() {
      // Only run this once on the root instance
      if (this.$root === this) {
        this.detectTouchDevice();
      }
    },
    methods: {
      detectTouchDevice() {
        const isTouchDevice = (
          ('ontouchstart' in window)
          || (navigator.maxTouchPoints > 0)
          || (navigator.msMaxTouchPoints > 0)
        );

        if (isTouchDevice) {
          document.body.classList.add('touch-device');
        } else {
          document.body.classList.add('no-touch-device');
        }
      },
    },
  });
}

